// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from "vue";
import ActionCableVue from "actioncable-vue";
import { EventBus } from "./eventBus";
import VueResource from "vue-resource";
import App from "./App";
import router from "./router";
import store from "./modules";
import ElementUI from "element-ui";
import VueHighcharts from "vue-highcharts";
import Highcharts from "highcharts";
import VueI18n from "vue-i18n";
import VueMoment from "vue-moment";
import moment from "moment-timezone";
import VueScrollTo from "vue-scrollto";
import VueKonva from "vue-konva";

import EsMessage from "./locales/es";
import EnMessage from "./locales/en";

import enLocale from "element-ui/lib/locale/lang/en";
import locale from "element-ui/lib/locale";

import "font-awesome/css/font-awesome.css";
import "./assets/element-for-ring.scss";
import "./assets/flex.css";
import "./assets/grid.css";

import "./modules/action-types";
import browserLocation from "@/helpers/BrowserLocation";
import axios from "axios";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";

import VueProgressBar from "vue-progressbar";
import VueTelInput from "vue-tel-input";
import "vue-tel-input/dist/vue-tel-input.css";

import GooglePlaceDirective from "@/components/Shared/GooglePlace/GooglePlaceDirective";
import { lowerCase, startCase, get, flatten, isEmpty } from "lodash";
import TimeZoneFormatter from "@/components/TimeZoneFormatter";

const envVars = process.env;
axios.defaults.baseURL = envVars.API_URL;

const options = {
  color: "#1ad6fdab",
  failedColor: "#fbe8e6",
  thickness: "5px",
  transition: {
    speed: "0.2s",
    opacity: "0.6s",
    termination: 200,
  },
  autoRevert: true,
  location: "top",
  inverse: false,
};

Vue.use(ActionCableVue, {
  debug: true,
  debugLevel: "error",
  connectImmediately: false,
});

Vue.component("font-awesome-icon", FontAwesomeIcon);
Vue.component("time-zone-formatter", TimeZoneFormatter);
Vue.use(VueProgressBar, options);
Vue.use(VueTelInput);

Vue.use(VueScrollTo);
Vue.use(VueMoment, { moment });
Vue.use(VueResource);
Vue.use(ElementUI, { locale: enLocale });
Vue.use(VueHighcharts, { Highcharts });
Vue.use(VueI18n);
// Vue.use(FontAwesomeIcon);
Vue.use(VueKonva);
Vue.use(VueTelInput);

Vue.config.productionTip = false;
Vue.http.options.root = envVars.API_URL;

const messages = {
  en: EnMessage,
  es: EsMessage,
};

Vue.component("WithVariable", {
  template: "<div><slot></slot></div>",
});

// Create VueI18n instance with options
const i18n = new VueI18n({
  locale: "en",
  fallbackLocale: "en",
  messages,
});

// Elemnt UI lang
locale.use(enLocale);

// Global filters
Vue.filter("sentenceCase", function (sentence) {
  if (!sentence) return "";
  let n = sentence.toString().replace(/_/g, " ").toLowerCase();
  return n.charAt(0).toUpperCase() + n.slice(1);
});
Vue.filter("capitalize", function (name) {
  if (!name) return "";
  let values = name.toString().replace(/_/g, " ").split(" ");
  return values.map((n) => n.charAt(0).toUpperCase() + n.slice(1)).join(" ");
});
Vue.filter("uppercase", function (value) {
  if (!value) return "";
  value = value.toString();
  return value.toUpperCase();
});
Vue.filter("truncate", function (value, size) {
  if (!value) return "";
  value = value.toString();
  if (value.length <= size) {
    return value;
  } else {
    return value.slice(0, size) + "...";
  }
});

Vue.filter("toMacAddress", function (value) {
  return value
    .toUpperCase()
    .replace(/(.{2})(.{2})(.{2})(.{2})(.{2})(.{2})/g, "$1:$2:$3:$4:$5:$6");
});
Vue.directive("googlePlaces", GooglePlaceDirective);

Vue.directive("acl", {
  bind(el, binding, vnode) {
    let action = Object.keys(binding.modifiers)[0];
    let permission = binding.value.permission;
    let resource = binding.value.on;

    let availableModifiers = ["enable", "show"];
    let availableNotModifiers = ["hide"];
    if (
      !availableModifiers.includes(action) &&
      !availableNotModifiers.includes(action)
    ) {
      throw Error(
        `Do not understand modifier [${action}]. Available modifiers: ${availableModifiers}.  Available !modifiers: ${availableNotModifiers}`
      );
    }

    function replaceWithComment() {
      // replace HTMLElement with comment node
      const comment = document.createComment(" ");
      Object.defineProperty(comment, "setAttribute", {
        value: () => undefined,
      });
      vnode.elm = comment;
      vnode.text = "";
      vnode.isComment = true;
      vnode.context = undefined;
      vnode.tag = undefined;
      vnode.data.directives = undefined;

      if (vnode.componentInstance) {
        vnode.componentInstance.$el = comment;
      }

      if (el.parentNode) {
        el.parentNode.replaceChild(comment, el);
      }
    }

    let restrictiveActions = {
      enable: () => el.classList.add("disable-html-component"),
      show: () => {
        replaceWithComment();
      },
      hide: () => {
        replaceWithComment();
      },
    };

    const user = JSON.parse(localStorage.getItem("user"));
    const acl = user["acl"];

    let aclResource = acl[resource] || {};

    if (aclResource[permission]) {
      if (availableNotModifiers.includes(action)) {
        restrictiveActions[action]();
      }
    } else {
      if (availableModifiers.includes(action)) {
        restrictiveActions[action]();
      }
    }
  },
});

Vue.directive("nd-link", {
  isFn: true,
  inserted: function (el, binding) {
    el.addEventListener("click", function (evt) {
      browserLocation.setTargetUrl(`${location.origin}${binding.arg}`);
      let callback = binding.value.callback;
      let params = binding.value.params || [];
      params.push(binding.arg);
      if (typeof callback === "function") callback(...params);
    });
  },
});

Vue.filter("startCase", function (value) {
  return typeof value === "string" ? startCase(value) : value;
});

Vue.filter("lowerCase", function (value) {
  return typeof value === "string" ? lowerCase(value) : value;
});
Vue.prototype.$EventBus = EventBus;
Vue.prototype.$forEachPlcError = function (resp, callback) {
  let messages = [];
  let hash =
    get(resp, "data.body.errors", null) || get(resp, "data.body", null);
  if (hash && hash.constructor == Object) {
    let lists = Object.values(hash).filter((v) => v.constructor == Array);
    let errors = lists.flat();
    messages = errors.map((err) => err.message || err);
  }
  if (isEmpty(messages)) callback(resp.data);
  // as Admin replies
  else messages.forEach((msg) => callback(msg)); // As PLC replies
};

/* eslint-disable no-new */
const app = new Vue({
  i18n,
  router,
  store,
  components: { App },
  template: "<App/>",
}).$mount("#app");

// initialize HEAP integration
if (!!window.heap && !!envVars.HEAP_ID) {
  window.heap.load(envVars.HEAP_ID);
  console.log("Initialize HEAP - Account ID: " + envVars.HEAP_ID);
}

export default app;
